import { render, staticRenderFns } from "./sub-lease.vue?vue&type=template&id=60e015c6"
import script from "./sub-lease.vue?vue&type=script&lang=js"
export * from "./sub-lease.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports